<template>
    <div class="aboutcon">
        <img style="height: 450px;width:100%;" src="../../assets/04-companyInfo/01-banner.jpg" alt="">
        <div style="padding: 50px 300px;">
            <div style="font-size: 28px;" class="color-97">企业资讯</div>
            <div style="padding: 50px 0;display: flex;border-bottom: 1px solid #ccc;">
                <div style="margin-right: 30px;">
                    <img style="height: 200px;" src="../../assets/04-companyInfo/02.jpg" alt="">
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 14px 0;">
                    <div style="font-size: 24px;font-weight: bold;" class="color-113-188">加强信息安全防线，汇柏网络安全攻防演练专题行动正式开启</div>
                    <div style="color: #000;">2024-5-10</div>
                    <div class="color-69">近日，为进一步提升企业网络安全防护能力，确保信息系统安全稳定运行，我司成功举行了一场网络安全攻防演练。此次演练汇聚了公司内部网络安全团队及外部专业安全机构的专家，共同模拟了多种网络攻击场景，检验了企业的网络安全防护体系。</div>
                </div>
            </div>
            <div style="padding: 50px 0;display: flex;">
                <div style="margin-right: 30px;">
                    <img style="height: 200px;" src="../../assets/04-companyInfo/03.jpg" alt="">
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 14px 0;">
                    <div style="font-size: 24px;font-weight: bold;" class="color-113-188">积极践行绿色责任，共植希望之树</div>
                    <div style="color: #000;">2024-3-12</div>
                    <div class="color-69">在春意盎然的植树节之际，汇柏软件积极响应国家号召，组织员工前往植树点开展义务植树活动。此次活动不仅体现了企业对于环境保护的重视，也展现了员工们对于绿色生态的热爱和责任感植树现场，大家热情高涨，纷纷拿起铁锹、挖坑、培土、浇水，共同种下了一棵棵希望的树苗。企业领导也亲自参与植树，与员工们一起挥洒汗水，共同为绿色生态贡献一份力量。</div>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import foot from '../../components/foot'
export default {
    data:function(){
        return {
            
        }
    },
    components:{
        foot
    },
    mounted(){
        
    },
    methods:{
         
    },
}
</script>
<style lang="less" scoped>
.color-97 {
    color: rgb(97, 97, 97);
}

.color-69 {
    color: rgb(69, 69, 69);
}

.color-113-188 {
    color: rgb(0, 113, 188);
}
</style>






// WEBPACK FOOTER //
// src/views/aboutUs/aboutUs.vue